import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'equine-ui-nx-canceled-landing',
  standalone: true,
  imports: [
    MatIcon,
    MatButton
  ],
  templateUrl: './canceled-landing.component.html',
  styleUrl: './canceled-landing.component.scss',
})
export class CanceledLandingComponent {
  constructor(
    private readonly router: Router
  ){}

  goToDashboard() {
    this.router.navigate(["dashboard"]).then(() => {
      window.location.reload();
    });
  }
}
